import Button from "components/Buttons/Button/Button";
import { regax } from "helpers/const";
import useAPI from "hooks/useAPI";
import { useEffect } from "react";
import { useState } from "react";
import styles from "./ForgotPassword.module.scss";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import Loading from "components/Loading/Loading";
import { useTranslation } from "react-i18next";
import { printError } from "../../helpers/apiError";

const FrogotPasword = ({ openDialog, setOpenDialog, enteredEmail, translateKey }) => {
    const { t } = useTranslation();

    const api = useAPI();
    const [emailValue, setEmailValue] = useState(enteredEmail);
    const [message, setMessage] = useState(null);

    const [isLoading, setIsLoading] = useState(false);
    const [isSent, setIsSent] = useState(false);

    useEffect(() => {
        if (openDialog) {
            setEmailValue(enteredEmail);
        } else {
            setIsSent(false);
            setIsLoading(false);
            setMessage(null);
        }
    }, [openDialog, enteredEmail]);

    const submitHandler = () => {
        if (isLoading || isSent) return;
        let mail = (emailValue ?? "").trim();
        if (mail !== "" && regax.test(mail)) {
            setIsLoading(true);
            setMessage(null);
            api.post("customer/forgot-password", { email: mail })
                .then((response) => {
                    setIsLoading(false);
                    setMessage(response.message);
                    setIsSent(true);
                })
                .catch((error) => {
                    console.warn(error);
                    setMessage(printError(error) ? printError(error) : t("global-message-unknown_error"));
                    setIsLoading(false);
                });
        } else {
            setMessage(t(`${translateKey}-form-field-email-error-not_valid`));
        }
    };

    return (
        <Dialog
            open={openDialog}
            onClose={() => {
                setOpenDialog(false);
            }}
            fullWidth
            maxWidth="sm"
            aria-labelledby="forgot-password-title"
            aria-describedby="forgot-password-description"
            PaperProps={{
                className: styles.paper,
                component: "form",
                noValidate: true,
                onSubmit: (event) => {
                    event.preventDefault();
                    submitHandler();
                },
            }}
        >
            <DialogTitle id="forgot-password-title">
                {t(`${translateKey}-title`)}
                <button type="button" className={styles.close} aria-label="Zatvori" onClick={() => setOpenDialog(false)}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" /></svg>
                </button>
            </DialogTitle>
            <DialogContent>
                <div className={styles.contentContainer}>
                    <p id="forgot-password-description">{t(`${translateKey}-description`)}</p>

                    {!isLoading ? (
                        <>
                            {!isSent && (
                                <>
                                    <label htmlFor="forgot-password-email">{t(`${translateKey}-form-field-email-label`)}</label>
                                    <input
                                        id="forgot-password-email"
                                        type="email"
                                        autoComplete="email"
                                        value={emailValue ?? ""}
                                        aria-invalid={Boolean(message && !isSent)}
                                        aria-describedby={message ? "forgot-password-message" : undefined}
                                        onChange={(e) => {
                                            setEmailValue(e.currentTarget.value);
                                        }}
                                        className="form-control"
                                    />
                                </>
                            )}
                            {message && <div id="forgot-password-message" role="status" className={`${styles.message} ${isSent ? styles.success : styles.error}`}>{message}</div>}
                        </>
                    ) : (
                        <Loading size={28} />
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    className={styles.cancel}
                    onClick={() => {
                        setOpenDialog(false);
                    }}
                    label={t(`${translateKey}-form-button-close`)}
                />
                {!isSent && <Button className={styles.submit} type="submit" label={t(`${translateKey}-form-button-submit`)} disabled={isLoading} />}
            </DialogActions>
        </Dialog>
    );
};

export default FrogotPasword;
